
import Vue from "vue"

const state = {
  version: []
}

const getters = {
  version: state => state.version,
}

const actions = {
  load_version ({commit}) {
    Vue.axios
      .get('pricelist-version')
      .then(r => r.data)
      .then(version => {
        commit('SET_VERSION', version[0])
      })
  },

}

const mutations = {

  SET_VERSION (state, version) {
    state.version = version
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/version.js